// @ts-strict-ignore
import React from 'react';
import { Card } from '@usealloy/component-library';

import { DEFAULT_COLUMNS } from '~/entities/evaluations/transaction/history/constants';
import TransactionHistory from '~/entities/evaluations/transaction/history/TransactionHistory';

import { useEventTypeEvaluationsContext } from '../context';

const RecentTransactions = () => {
  const { entity } = useEventTypeEvaluationsContext();
  const transactionColumns = {
    priority_columns: [...DEFAULT_COLUMNS.priority],
    secondary_columns: [...DEFAULT_COLUMNS.secondary],
  };

  return (
    <Card
      header="Recent Transactions"
      collapsible
    >
      <TransactionHistory
        hasEvidenceModal
        entity={entity}
        transactionColumns={transactionColumns}
        isActionable
        canSendWebhookFromPage={false}
        canUpdateStatus={false}
      />
    </Card>
  );
};

export default RecentTransactions;
